import React, { useEffect, useMemo } from 'react';
import {
  Dropdown,
  useFormContextRequired,
  useListContextRequired,
  useShowContext
} from 'ui-builder';
import { ProjectDetailsField, ProjectDetailsFieldType, ProjectType } from 'nekst-api';

export default function ParentFieldDropdown(props: {
  isDisabled?: boolean;
}) {
  const listContext = useListContextRequired<ProjectDetailsField>();

  const showContext = useShowContext<ProjectDetailsField>();

  const formContext = useFormContextRequired<ProjectDetailsField & {
    _availableProjectTypes?: ProjectType[];
  }>();

  const currentField = showContext?.data;

  const options = useMemo(() => {
    const getChildrenIds = (currentFieldId: number): number[] => {
      const directChildren = listContext.data.filter((field) => field.parentFieldId === currentFieldId);

      return [
        ...directChildren.map((field) => field.id),
        ...directChildren.flatMap((field) => getChildrenIds(field.id))
      ];
    };

    return listContext.data!
      .filter((item) => item.fieldType === ProjectDetailsFieldType.DATE)
      .filter((item) => currentField && item.id !== currentField.id && !getChildrenIds(currentField.id)
        .includes(item.id))
      .map((item) => ({
        value: item.id,
        label: item.name
      }));

  }, [listContext.version]);

  const parentFieldId = formContext.data?.parentFieldId;

  useEffect(() => {
    if (parentFieldId) {
      const parentField = listContext.data.find((field) => field.id === parentFieldId);

      if (parentField) {
        const availableProjectTypes = parentField.projectTypes;

        const currentProjectTypes = formContext.data?.projectTypes || [];

        // update currentProjectTypes and exclude those not available in parent field
        const updatedProjectTypes = currentProjectTypes.filter((type) => availableProjectTypes.includes(type));

        formContext.onChangeCallback({
          projectTypes: updatedProjectTypes,
          _availableProjectTypes: availableProjectTypes
        });
      } else {
        formContext.onChangeCallback({
          _availableProjectTypes: undefined
        });
      }
    } else {
      formContext.onChangeCallback({
        _availableProjectTypes: undefined
      });
    }

  }, [parentFieldId]);

  if (formContext?.data?.fieldType === ProjectDetailsFieldType.DATE) {
    return (
      <Dropdown
        options={options}
        source="parentFieldId"
        label="Parent Detail Box"
        isClearable={true}
        isDisabled={options.length === 0 || props.isDisabled}
        title={options.length === 0 ? 'No available parent fields' : undefined}
      />
    );

  } else {
    return null;
  }

}
